import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
    HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

import { environment } from '@environments/environment';
import { AuthService } from '@services/api/auth/auth.service';

export const authInterceptor: HttpInterceptorFn = (
    req: HttpRequest<any>,
    next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
    const authService = inject(AuthService);

    const reqClone = req.clone(
        environment?.local
            ? { setHeaders: { Authorization: `Bearer ${environment.token}` } }
            : { withCredentials: true },
    );

    return next(reqClone).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === HttpStatusCode.Unauthorized) {
                authService.logout();
            }
            return throwError(() => error);
        }),
    );
};
